
import Alert from 'vux/src/components/alert/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
Cell,
Group,
CellBox,
Confirm,
Alert,
XButton,
Tab,
TabItem,
Swiper,
SwiperItem
},
data() {
return {
select: '',
orders_unclosed: [],
list: ['故障记录'],
index: 0,
role: '',
loadmoreone: '加载更多',
isDisabled: false,
iden: '',
data: {},
show: true,
}
},
methods: {
showMoreorders() {
this.isDisabled = true
this.loadmoreone = '加载中'
var offset = this.orders_unclosed.length
let opid = localStorage.getItem('userid');
var that = this
var header = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}

this.$http.get('api/v1/devices/' + this.data.seq + '/warnings?offset=' + offset + '&count=10&role=' + this.iden, header)
.then(res => {
console.log(res)
that.isDisabled = false

if (res.data.contents.length > 0) {
that.loadmoreone = '加载更多'
} else {
that.show = false
}
var orders = []
orders = res.data.contents

for (var i = 0; i < orders.length; i++) {
if (orders[i].level == 0) {
orders[i].level = '未分类'
}
if (orders[i].level == 1) {
orders[i].level = '信息'
}
if (orders[i].level == 2) {
orders[i].level = '警告'
}
if (orders[i].level == 3) {
orders[i].level = '错误'
}
if (orders[i].level == 4) {
orders[i].level = '紧急'
}
if (orders[i].level == 5) {
orders[i].level = '灾难'
}

if (orders[i].action == 0) {
orders[i].action = '故障恢复'
}
if (orders[i].action == 1) {
orders[i].action = '故障发生'
}


that.orders_unclosed.push(orders[i])
}
})
.catch(err => {
console.log(err.response)
})

}
},
created() {
let opid = localStorage.getItem('userid');
var order = localStorage.getItem('order')

if (order) {
this.data = JSON.parse(order)
} else {
this.data = this.$route.params.data
}
console.log(this.data)
var that = this;
var header = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}
this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
for (let i = 0; i < res.data.length; i++) {
if (res.data[i].type == 'INDV') {
that.iden = 'INDV'
}
if (res.data[i].type == 'ENTP') {
that.iden = 'ENTP'
}
}
that.$http.get('api/v1/devices/' + that.data.seq + '/warnings?offset=0&count=10&role=' + that.iden, header)
.then(res => {
that.orders_unclosed = res.data.contents
for (var i = 0; i < that.orders_unclosed.length; i++) {
if (that.orders_unclosed[i].level == 0) {
that.orders_unclosed[i].level = '未分类'
}
if (that.orders_unclosed[i].level == 1) {
that.orders_unclosed[i].level = '信息'
}
if (that.orders_unclosed[i].level == 2) {
that.orders_unclosed[i].level = '警告'
}
if (that.orders_unclosed[i].level == 3) {
that.orders_unclosed[i].level = '错误'
}
if (that.orders_unclosed[i].level == 4) {
that.orders_unclosed[i].level = '紧急'
}
if (that.orders_unclosed[i].level == 5) {
that.orders_unclosed[i].level = '灾难'
}

if (that.orders_unclosed[i].action == 0) {
that.orders_unclosed[i].action = '故障恢复'
}
if (that.orders_unclosed[i].action == 1) {
that.orders_unclosed[i].action = '故障发生'
}


}
console.log(res)
})
.catch(err => {
console.log(err.response)
})


})
}
}



// WEBPACK FOOTER //
// ./src/components/recordlist.vue